import styled from "styled-components"


export const Wrapper = styled.div`
padding-top:30px ;
display: flex;
justify-content: center;
align-items: center;
  `
export const Ledger = styled.div`
display: flex;
flex-direction: column;
overflow: hidden;
white-space: nowrap;
color: var(--font-color-gray4f4f4f);
font-family: var(--general-body-font-family);
font-size: var(--general-body-font-size);
font-style: normal;
font-weight: var(--general-body-font-weight);
line-height: normal;
text-transform: capitalize;
`
export const SubLedger = styled.span`
color: var(--font-color-blue002e5c);
font-size: var(--general-caption-font-size);
font-weight: var(--general-caption-font-weight);
opacity: 0.800000011920929;
`
export const Spinner = styled.div`
width: 100%;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
`
export const NoOpenCharges = styled.div`
width:100%;
height: inherit;
display: flex;
justify-content: center;
align-items: center;
font-weight: var(--general-header-font-weight);
font-size: var(--general-header-font-size);

`
export const Header = styled.div`
width: 100%;
height: 91px;
display: flex;
justify-content: left;
align-items: center;
`

export const ImageContainer = styled.div`
    height:${(props) => (props.isMobile ? '100%' : '227.966px')};
    overflow: hidden;
    display: flex;
    justify-content: space-between;
`
export const ImageCard = styled.img`
    float: right;
    margin-right:${(props) => (props.isMobile ? '-147px' : '20px')};
`
export const CardContent = styled.div`
    margin-left: 35px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color:var(--font-color-white);
    font-style: normal;
    line-height: 161.5%;
    width: 100%;
    h1{
    font-weight: var(--font-weight-bold);
    font-size:${(props) => (props.isMobile ? 'var(--general-header-font-size)' : 'var(--general-page-header-font-size)')};
    width: 100%;
    }
    span{
        width: fit-content;
    padding: 3px 5px;
        height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: var(--Blue-20, #EAEEFC); 
    color:var(--font-color-blue2555ef);
    margin-top: ${(props) => (props.isMobile ? '6px' : '50px')};
    }
`
export const PaymentButtonSubmit = styled.div`
display: flex;
justify-content: center;
align-items: center;
height: 44px;
/* margin-top: -65px; */
margin-bottom: 20px;

button{
display: flex;
border-radius: 5px;
justify-content: center;
align-items: center;
background:${(props) => (props.isDisabled ? 'var(--Gray-20, #F0F0F3)' : 'var(--blues-blue-main, #2555EF)')};
padding: 8px 20px;
width:40% ;
height: 100%;
border: 0;
color: ${(props) => (props.isDisabled ? 'var(--Gray-100, #B5B5C3)' : 'var(--White, var(--White-100, #FFF))')};
font-size: var(--general-button-font-size);
font-weight: var(--general-button-font-weight);
line-height: 32px; 
:hover{
    background:${(props) => (props.isDisabled ? 'var(--Gray-20, #F0F0F3)' : '#214DD7')};
}
}

`